export enum PiqPopupTab {
    Questionnaires = 1,
    DataTables = 2,
}

export const PiqPopupTabs = [
    { id: PiqPopupTab.Questionnaires, content: 'Questionnaires' },
    {
        id: PiqPopupTab.DataTables,
        content: 'Data Tables',
    },
];
